import script from "./CardCommentComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./CardCommentComponent.vue?vue&type=script&setup=true&lang=js"

import "./CardCommentComponent.vue?vue&type=style&index=0&id=042c4675&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-042c4675"]])

export default __exports__